import submit from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-form/actions/submit';

import {
    ADD_TRACKED_ERRORS,
    REMOVE_TRACKED_ERRORS,
} from '@gov.wa.lni/application.child-labor-complaint/source/utils';

export default () => ({
    state: {
        isLoading    : false, // For spinner on submit
        trackedErrors: [],
    },
    actions  : { submit },
    mutations: {
        ADD_TRACKED_ERRORS,
        REMOVE_TRACKED_ERRORS,
    },
});